import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    logUsageLimit?: number | null;
    networkUsageLimit?: number | null;
    orgLabel?: string;
  }>()
  .create(({ theme, logUsageLimit, networkUsageLimit, orgLabel }) => ({
    dashboardPage: {
      display: 'grid',
      gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(5, minmax(8rem, 1fr))',
      gap: '1.5rem',
      height: '100%',
      [theme.breakpoints.down('xl')]: {
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gridTemplateRows: 'repeat(14, minmax(200px, 1fr))'
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gridTemplateRows: 'repeat(9, minmax(auto, 300px))'
      }
    },
    dashboardPageContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    dashboardStackedItem: {
      display: 'grid',
      gap: '1.5rem',
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 2',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardMediumItem: {
      borderRadius: 4,
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 2',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardLargeItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 4',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardSmallItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 1',
      gridColumn: 'span 1'
    },
    dashboardRecentTickets: {
      height: '100%',
      width: '100%',
      gridColumn:
        (logUsageLimit || networkUsageLimit) && orgLabel !== 'all'
          ? 'span 2'
          : 'span 3',
      gridRow: 'span 2',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    tab: {
      color: theme.vars.palette.text.secondary,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem',
        minWidth: '3rem'
      }
    },
    time: {
      display: 'inline-block',
      marginRight: theme.spacing(1)
    },
    ticketsTable: {
      '& .ag-header-container': {
        backgroundColor: theme.vars.palette.background.elevation2,
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.5rem'
      }
    }
  }));

export default useStyles;
